export function socialShare() {
    (function() {
        /**
         * Social Sharing
         */
        function socialWindow(url) {
            var left = (screen.width - 570) / 2;
            var top = (screen.height - 570) / 2;
            var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
            window.open(url, "NewWindow", params);
        }

        function setShareLinks() {
            let url;
            let pageUrl = encodeURIComponent(document.URL);

            $(".share-facebook").on("click", function () {
                url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
                socialWindow(url);
                return false;
            });

            $(".share-x").on("click", function () {
                url = "https://twitter.com/intent/tweet?url=" + pageUrl;
                socialWindow(url);
                return false;
            });
            
            $(".share-linkedin").on("click", function () {
                url = "https://www.linkedin.com/shareArticle?mini=true&url=" + pageUrl;
                socialWindow(url);
                return false;
            });
        }
        setShareLinks();
    })();
}